<template>
  <div class="BWSelect temr">
    <van-field
      readonly
      clickable
      :label="params.title"
      v-model="text"
      :placeholder="placeholder"
      right-icon="arrow"
      @click="showTermPicker = true"
    />
    <van-popup v-model="showTermPicker" position="bottom">
      <van-picker
        show-toolbar
        :default-index="defaultIndex"
        :columns="columnsTermData"
        @cancel="showTermPicker = false"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'BWSelect',
  props: ['params', 'placeholder', 'columnsTerm', 'form'],
  data() {
    return {
      showTermPicker: false,
      text: '',
      columnsTermData: [],
      defaultIndex: 0,
    };
  },
  mounted() {
    if (this.$route.query.productId === 'YL-YPD') {
      console.log('this.form', this.form);

      this.form.subscribe(() => {
        if (this.form.getValue('marriage') === '40' || this.form.getValue('marriage') === '10' || this.form.getValue('marriage') === '30') {
          this.updateState({
            prohibitionDivorce: true,
          });
          if (this.form.getValue('relationshipWith') === '11') {
            this.form.dispatch({ type: 'set', relationshipWith: '99999' });
          }

          console.log('prohibitionDivorce', this.prohibitionDivorce);
        } else if (this.form.getValue('marriage') !== '40' || this.form.getValue('marriage') !== '10' || this.form.getValue('marriage') !== '30') {
          this.updateState({
            prohibitionDivorce: false,
          });
        }
      }, 'marriage');
      // this.form.subscribe(() => {
      //   if (this.form.getValue('relationshipWith') === '配偶') {
      //   }
      // }, 'relationshipWith');
    }
  },
  computed: {
    ...mapState({
      prohibitionDivorce(val) {
        return val.publicPage.prohibitionDivorce;
      },
    }),
  },
  methods: {
    ...mapMutations('publicPage', ['updateState']),
    onConfirm(obj) {
      this.$emit('input', obj.value || '');
      this.showTermPicker = false;
      this.text = obj.text || '';
    },
  },
  watch: {
    prohibitionDivorce: {
      deep: true,
      immediate: true,
      handler() {
        if (this.params.field === 'relationshipWith' && this.prohibitionDivorce) {
          this.columnsTermData = this.columnsTerm.map((item) => {
            if (item.text === '配偶') {
              return {
                ...item,
                disabled: true,
              };
            }
            return item;
          });
        } else {
          this.columnsTermData = this.columnsTerm;
        }
      },
    },
    'params.initValue': {
      handler(val) {
        if (val) {
          this.defaultIndex = this.columnsTerm.findIndex((e) => e.value === val.toString());
          console.log('defaultIndex', this.defaultIndex);
          if (this.defaultIndex === -1) {
            this.onConfirm({});
            return;
          };
          const findIndexVal = this.columnsTerm[this.defaultIndex];
          this.onConfirm(findIndexVal);
        }
      },
    },
  },
};
</script>
<style scoped>
.BWSelect{
  position: relative;
}
>>> .van-field__label {
  text-align: left;
  color: #46494D;
  width: 86px;
  margin-right: 16px;
}
.van-picker__cancel,
.van-picker__confirm {
  color: #ff6538;
}
>>> .van-field__control::-webkit-input-placeholder {
  font-size: 16px;
  color: #BCC2CC;
}
>>> .van-field__control::-moz-input-placeholder {
  font-size: 16px;
  color: #BCC2CC;
}
>>> .van-field__control::-ms-input-placeholder {
  font-size: 16px;
  color: #BCC2CC;
}
>>> .van-cell::after{
  border-bottom: none !important;;
}
.temr::after {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  margin: 0 16px;
  box-sizing: border-box;
  border-bottom: 1px solid #dddee1;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
  content: ' ';
  pointer-events: none;
}
>>> .van-field__body{
  font-size: 16px;
}
</style>
